import { Phone } from '@livecontrol/locale-us';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';
import type { Maybe } from '../../../../graphql-types';
// eslint-disable-next-line import/no-internal-modules
import type { ContactRole } from '../../graphql/__generated__/use-scheduled-event';
import S = Matrix.Stack;
import Card = S.Card;

interface Props {
  contacts: Maybe<ContactRole>[];
}

export const TroubleshootingStack = ({ contacts }: Props): React.ReactElement => (
  <S>
    {contacts
      .filter((v): v is NonNullable<typeof v> => !!v)
      .map(
        (contact): React.ReactElement => (
          <Card key={contact.user?.id}>
            <Card.Body>
              <Card.Row label='Priority'>{contact.onsite_technical_priority}</Card.Row>
              <Card.Row label='Name'>{contact.user?.first_name}</Card.Row>
              <Card.Row label='Email'>{contact.user?.email}</Card.Row>
              <Card.Row label='Phone Number'>
                {Phone.normalize(contact.user?.phone_number)?.format({ parenthetical: true }) ??
                  contact.user?.phone_number}
              </Card.Row>
              <Card.Row label='Preference'>{contact.user?.preferred_contact_method}</Card.Row>
              <Card.Row label='Notes'>{contact.user?.additional_information}</Card.Row>
            </Card.Body>
          </Card>
        )
      )}
  </S>
);
